import { Component, EventEmitter, OnInit } from '@angular/core';
import {
  DwButtonCommand,
  DwButtonConfig,
  DwModalConfig,
  DwModalHandler,
  DwModalResult
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { ReportFilterPresetOwnershipType } from '../../models/report-filter-preset.model';

export interface ReportFilterPresetSaveModalData {
  name?: string;
  canShareWithFlightSchool: boolean;
  canSaveSystem: boolean;
  updating: boolean;
  ownershipType?: ReportFilterPresetOwnershipType;
}

export interface ReportFilterPresetSaveModalResult {
  name: string;
  ownershipType: ReportFilterPresetOwnershipType;
}

@Component({
  selector: 'app-report-filter-preset-save-modal',
  templateUrl: './report-filter-preset-save-modal.component.html'
})
export class ReportFilterPresetSaveModalComponent implements OnInit, DwModalHandler {
  modalConfig: DwModalConfig<ReportFilterPresetSaveModalData>;
  closeModal = new EventEmitter<DwModalResult<ReportFilterPresetSaveModalResult>>();
  name = '';
  ownershipType = ReportFilterPresetOwnershipType.User;
  errorMessage: string;
  readonly OwnershipType = ReportFilterPresetOwnershipType;

  ngOnInit(): void {
    this.name = this.modalConfig.data?.name || '';
    this.ownershipType = this.modalConfig.data?.ownershipType || ReportFilterPresetOwnershipType.User;
  }

  buttonClick(button: DwButtonConfig): Observable<DwModalResult<ReportFilterPresetSaveModalResult>> {
    if (button.command !== DwButtonCommand.saveAndClose) {
      return of({ cancelled: true, closeModal: true, buttonCommand: button.command } as any);
    }
    if (!this.name?.trim()) {
      this.errorMessage = 'A view name is required.';
      return of({ closeModal: false } as any);
    }
    if (this.ownershipType === ReportFilterPresetOwnershipType.FlightSchool
      && !this.modalConfig.data?.canShareWithFlightSchool) {
      this.errorMessage = 'Only Flight School administrators can save shared school views.';
      return of({ closeModal: false } as any);
    }
    if (this.ownershipType === ReportFilterPresetOwnershipType.System && !this.modalConfig.data?.canSaveSystem) {
      this.errorMessage = 'Only Pilexos administrators can save recommended system views.';
      return of({ closeModal: false } as any);
    }
    return of({
      cancelled: false,
      closeModal: true,
      buttonCommand: button.command,
      data: { name: this.name.trim(), ownershipType: this.ownershipType }
    } as any);
  }
}
